import * as ngCore from '@angular/core'

import * as data from '../../data'
import { AtnDsTableStore } from '../../store'

import * as pagination from './pagination'
import * as search from './search'

@ngCore.Component({
  imports: [data.Component, pagination.Component, search.Component],
  selector: 'embedded-container',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link AtnDsTableStore} */
  public readonly store = ngCore.inject(AtnDsTableStore)
}
